var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 53,
    viewBox: "0 0 30 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "marker"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 24",
    d: "M30 15C30 16.8631 27.2751 27.3163 22.5 36.5C18.0355 45.0864 11.5 52.5 11.5 52.5C11.5 52.5 19.6792 30 15 30C6.71573 30 0 23.2843 0 15C0 6.71573 6.71573 0 15 0C23.2843 0 30 6.71573 30 15Z",
    fill: "#4A98DF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 23",
    cx: 15,
    cy: 15,
    r: 12,
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarker);
export default __webpack_public_path__ + "static/media/marker.c01e528ae56f60376c866e219fc5d342.svg";
export { ForwardRef as ReactComponent };